import React from "react";

const BestSeasons = ({ bestSeasons }) => {
  if (
    !bestSeasons ||
    bestSeasons.length === 0 ||
    bestSeasons.every((season) => !season.trim())
  ) {
    return null;
  }

  return (
    <div className="py-2">
      <h2 className="text-sm font-semibold text-gray-800 dark:text-gray-200 mb-2">
        Best Seasons
      </h2>
      <div className="flex space-x-2 overflow-x-auto">
        {bestSeasons.map((season, index) => (
          <div
            key={index}
            className="bg-gray-200 dark:bg-gray-700 px-3 py-1 rounded-md"
          >
            <p className="text-xs text-gray-800 dark:text-gray-300 font-semibold">
              {season}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default React.memo(BestSeasons);
